import { render } from "./CategoryForm.vue?vue&type=template&id=55ad1683"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__